import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

export interface ErroresLayoutData {
  errores: string[];
}

@Component({
  selector: 'app-errores-layout',
  templateUrl: './errores-layout.component.html'
})
export class ErroresLayoutComponent {

  errores: string[];

  constructor(
    public dialogRef: MatDialogRef<ErroresLayoutComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ErroresLayoutData
  ) {
    this.errores = data.errores;
  }

  cerrar() {
    this.dialogRef.close();
  }

}
